import { PropsWithChildren } from 'react'

import { InspectorContext } from '@cash-web/shared-data-access-redux-inspect'
import { devToolsEnabled } from '@cash-web/shared-devtools-data-access-context'

export const ReduxStateInspector = ({ children }: PropsWithChildren) => (
  <InspectorContext.Provider value={{ enabled: devToolsEnabled }}>{children}</InspectorContext.Provider>
)
